/*
 * @Date: 2023-01-04 14:58:29
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-01-20 18:00:45
 * @FilePath: \nicee-web-tw\src\router\router-notice.js
 * @Description: 公告路由
 */

const routers = [
  // 违法公告
  {
    path: '/notice-illegal',
    name: 'Illegal',
    component: () => import('@/upgrade-page/views/notice/illegal/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  },
  //
  {
    path: '/voice-room-preview',
    name: 'VoiceRoomPreview',
    component: () => import('@/upgrade-page/views/notice/voice-room-preview/index.vue'),
    meta: {
      hideNav: true,
      pageWidth: '100%',
      needMedia: true
    }
  }
];
export default routers;
